/**
 * The address that opens one lead's drawer (19.10.2026). The leads tab reads
 * `?lead=<id>` and takes it off the address once the drawer is open.
 * `/admin?tab=leads&lead_id=…` redirected to `/admin/leads` and lost the id.
 */
export const LEAD_PARAM = "lead";

export function leadHref(id) {
  return `/admin/leads?${LEAD_PARAM}=${encodeURIComponent(id || "")}`;
}
